import { useEffect } from 'react';
import PropTypes from 'prop-types';

const GlobalItemChangeListener = ({ isChanged }) => {

    useEffect(() => {
        if (isChanged) {
        }
    }, [isChanged]);

    return null;
};

GlobalItemChangeListener.propTypes = {
    isChanged: PropTypes.bool,
};

export default GlobalItemChangeListener;
